import { create } from 'zustand';
import fetchEndpoint from '../services/fetchEndpoint';

export interface DiseaseVocabularyCode {
  vocabulary: string;
  code: string;
  name: string;
}

interface DiseaseVocabularyEntry {
  status: 'loading' | 'loaded' | 'error';
  codes: DiseaseVocabularyCode[];
}

interface DiseaseVocabularyCodesState {
  entries: Record<string, DiseaseVocabularyEntry>;
  fetchDiseaseCodes: (diseaseUMLSCUI: string, authorization: string, isAuthenticated: boolean) => void;
}

export const useDiseaseVocabularyCodesStore = create<DiseaseVocabularyCodesState>()((set, get) => ({
  entries: {},
  fetchDiseaseCodes: (diseaseUMLSCUI, authorization, isAuthenticated) => {
    if (!diseaseUMLSCUI) return;
    const existing = get().entries[diseaseUMLSCUI];
    if (existing && (existing.status === 'loading' || existing.status === 'loaded')) return;

    set(state => ({
      entries: {
        ...state.entries,
        [diseaseUMLSCUI]: { status: 'loading', codes: [] },
      },
    }));

    const unauth = isAuthenticated ? '' : '?skey=unauth';
    const endpoint = `api/disease/detail/${diseaseUMLSCUI}${unauth}`;

    fetchEndpoint(endpoint, authorization, null)
      .then((result: any) => {
        const codes: DiseaseVocabularyCode[] =
          result?.status === 'OK' && Array.isArray(result?.payload?.diseaseCodes)
            ? result.payload.diseaseCodes
            : [];
        set(state => ({
          entries: {
            ...state.entries,
            [diseaseUMLSCUI]: { status: 'loaded', codes },
          },
        }));
      })
      .catch(() => {
        set(state => ({
          entries: {
            ...state.entries,
            [diseaseUMLSCUI]: { status: 'error', codes: [] },
          },
        }));
      });
  },
}));
